import { ArrowRight, Heart } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export function ContributeCTA() {
  return (
    <div className="eth-card text-center px-6 py-10 flex flex-col items-center gap-6">
      <div className="w-14 h-14 rounded-2xl bg-primary-muted flex items-center justify-center">
        <Heart
          size={28}
          className="text-primary"
          weight="duotone"
        />
      </div>

      <div>
        <h2 className="text-2xl font-bold text-text-primary mb-2">
          Want to contribute?
        </h2>
        <p className="text-text-secondary max-w-lg mx-auto">
          Join the KuberCoin developer community. Pick an issue, submit a bug
          report or feature request, and help build the future of peer-to-peer
          digital money.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/join"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-white font-semibold hover:bg-primary-dark transition-colors shadow-md"
        >
          Apply to join
          <ArrowRight size={18} weight="bold" />
        </Link>
        <Link
          to="/login"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-border text-text-secondary font-semibold hover:border-primary hover:text-primary-light transition-colors"
        >
          Developer login
        </Link>
      </div>
    </div>
  );
}
